// src/services/authService
import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetUserInfoResponse, GetUserStatisticsResponse, PatchUserRequest, PatchUserResponse } from './types/TUserServices';

const URL_Prefix = '/user';

export const userService = createApi({
  reducerPath: 'userService',
  baseQuery: getBaseQuery,
  tagTypes: ['User'],
  endpoints: (builder) => ({
    userInfo: builder.query<GetUserInfoResponse, void>({
      query: () => ({
        url: `${URL_Prefix}/user_info/`,
        method: 'GET',
      }),
      providesTags: ['User'],
    }),
    statistics: builder.query<GetUserStatisticsResponse[], void>({
      query: () => ({
        url: `${URL_Prefix}/statistics/`,
        method: 'GET',
      }),
      providesTags: ['User'],
    }),
    patchUser: builder.mutation<PatchUserResponse, { uuid: string; formData: FormData }>({
      query: ({ uuid, formData }) => ({
        url: `${URL_Prefix}/${uuid}/`,
        method: 'PATCH',
        body: formData,
        // Для multipart/form-data не устанавливаем Content-Type, браузер сделает это автоматически
        headers: {
          // Явно убираем Content-Type для FormData
        },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
  useUserInfoQuery,
  useLazyUserInfoQuery,
  useLazyStatisticsQuery,
  usePatchUserMutation
} = userService;